import { Component, ViewChild } from "@angular/core";
import { Nav, Platform, Events } from "ionic-angular";

import { AngularFireAuth } from "angularfire2/auth";
import { AngularFireDatabase } from "angularfire2/database";

import { OneSignal } from "@ionic-native/onesignal";
import { SocialSharing } from "@ionic-native/social-sharing";
import { TranslateService } from "@ngx-translate/core";

@Component({
  templateUrl: "app.html",
  selector: "MyApp",
  providers: [OneSignal, SocialSharing]
})
export class MyApp {
  @ViewChild(Nav) nav: Nav;
  Cart: any = [];
  noOfItemsInCart: any;
  noOfItemsInFevrt: any;
  noOfItemsInNews: any;
  noOfItemsInOffer: any;
  name: any;
  imageUrl: any = "assets/img/profile.jpg";
  rootPage: string = "HomePage";
  public uid: string;

  constructor(
    public af: AngularFireAuth,
    public db: AngularFireDatabase,
    public platform: Platform,
    public socialSharing: SocialSharing,
    private oneSignal: OneSignal,
    private events: Events,
    private translateService: TranslateService
  ) {
    this.initializeApp();
  }

  ngOnInit() {
    this.uid = localStorage.getItem("uid");
    if (this.uid != null) {
      this.db
        .object("/users/" + this.uid)
        .valueChanges()
        .subscribe((res: any) => {
          this.name = res.name;
          this.imageUrl =
            res.image != "" && res.image != null
              ? res.image
              : "assets/img/profile.jpg";
        });
    }
    this.useTranslateService();
    this.getNewsCount();
    this.getOfferCount();
    this.listenEvents();
  }

  private getNewsCount() {
    this.db
      .list("/news")
      .valueChanges()
      .subscribe(res => {
        this.noOfItemsInNews = res.length;
      });
  }

  private getOfferCount() {
    this.db
      .list("/menuItems", ref => ref.orderByChild("offer").equalTo(true))
      .valueChanges()
      .subscribe(queriedItems => {
        this.noOfItemsInOffer = queriedItems.length;
      });
  }

  private listenEvents() {
    this.events.subscribe("imageUrl", response => {
      this.imageUrl =
        response.image != "" && response.image != null
          ? response.image
          : "assets/img/profile.jpg";
      this.name = response.name;
    });
  }

  private useTranslateService() {
    let value = localStorage.getItem("language");
    let language = value != null ? value : "es";
    language == "ar"
      ? this.platform.setDir("rtl", true)
      : this.platform.setDir("ltr", true);
    this.translateService.use(language);
  }

  openPage(page) {
    this.nav.setRoot(page.component);
  }

  initializeApp() {
    if (this.platform.ready()) {
      this.platform.ready().then(res => {
        if (res == "cordova") {
          this.oneSignal.startInit(
            "9740a50f-587f-4853-821f-58252d998399",
            "714618018341"
          );
          this.oneSignal.getIds().then(response => {});
          this.oneSignal.inFocusDisplaying(
            this.oneSignal.OSInFocusDisplayOption.InAppAlert
          );
          this.oneSignal.handleNotificationReceived().subscribe(() => {});
          this.oneSignal.handleNotificationOpened().subscribe(() => {});
          this.oneSignal.endInit();
        }
      });
    }
  }

  home() {
    this.nav.setRoot("HomePage");
  }

  yourOrders() {
    this.nav.push("OrdersPage");
  }

  addToCart() {
    this.nav.push("CartPage");
  }

  catagory() {
    this.nav.push("CategoryPage");
  }

  favourite() {
    this.nav.push("FavouritePage");
  }

  offer() {
    this.nav.push("OfferPage");
  }

  news() {
    this.nav.push("NewsPage");
  }

  contact() {
    this.nav.push("ContactPage");
  }

  aboutUs() {
    this.nav.push("AboutUsPage");
  }

  settings() {
    this.nav.push("Settings");
  }

  invite() {
    this.socialSharing.share(
      "compartir la app!",
      null,
      null,
      "https://pedidos.data.com.uy/"
    );
  }

  chat() {
    this.nav.push("ChatPage");
  }
  tableBooking() {
    this.nav.push("TableBookingPage");
  }
  bookingHistory() {
    this.nav.push("BookingHistoryPage");
  }

  login() {
    this.nav.setRoot("LoginPage");
  }

  logout() {
    this.af.auth.signOut();
    localStorage.removeItem("uid");
    this.imageUrl = "assets/img/profile.jpg";
    this.nav.setRoot("LoginPage");
  }

  isLoggedin() {
    return localStorage.getItem("uid") != null;
  }

  isCart() {
    this.Cart = JSON.parse(localStorage.getItem("Cart"));
    this.noOfItemsInCart = this.Cart != null ? this.Cart.length : null;
    return true;
  }
}



// WEBPACK FOOTER //
// ./src/app/app.component.ts